import React from "react";
import {IDefaultIconProps} from "modules/types";

interface IProps extends IDefaultIconProps {
	stroke?: string;
}

export const IconClock: React.FC<IProps> = ({color = "#222222", stroke = "#FFF", ...rest}) => {
	return (
		<svg
			width="14"
			height="14"
			viewBox="0 0 14 14"
			xmlns="http://www.w3.org/2000/svg"
			{...rest}>
			<path
				d="M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14Z"
				fill={color}
			/>
			<path d="M7 2V7L10 10" stroke={stroke} />
		</svg>
	);
};
